import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step530031Meta extends BaseModel {
  /**
   * @var {?boolean}
   */
  isPartnerPermanentResidentOfCountry;

  constructor(model = {}) {
    super();
    this.isPartnerPermanentResidentOfCountry = model.isPartnerPermanentResidentOfCountry ?? null;
  }
}
